import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

export default class Error extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    sended: PropTypes.bool
  }

  renderError() {
    return this.props.data.map(element => {
      return (
        <div className={styles.error} key={element.fila}>
          <div className={styles.Email}>
            <b>Fila</b>: {element.fila}
          </div>
          <div className={styles.signers}>
            <div className="row">
              <div className="col-xs-12 col-sm-2">
                <div className={styles.signerTitle}>
                  <b>Firmantes</b>:
                </div>
              </div>
              <div className="col-xs-12 col-sm-10">
                <div className={styles.signerInformation}>
                  {element.signers.map(signer => {
                    return (
                      <div className="row" key={signer.email}>
                        <div className="col-xs-12 col-sm-6">
                          <div>Nombre: {signer.name} </div>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                          <div>Email: {signer.email} </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })
  }

  noError() {
    return <div className={styles.noError}>Los documentos enviados no presentaron errores.</div>
  }

  render() {
    if (!this.props.sended) return null
    if (isEmpty(this.props.data)) return this.noError()
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          El envío presentó algunos errores. A continuación se indica el numero de la fila de los
          elementos y sus firmantes:
        </div>
        <div className={styles.error}>{this.renderError()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/MassiveCreate/SendMassiveContract/Error/index.js